<template>
  <div class="body">
    <div class="post">
      <div class="column">
        <div class="header">{{ post }}</div>
        <div class="footer">
          <!-- {{ "财务共享中心 | 中心副主任 | 1人" }} -->
          {{
            company +
              (company ? " | " + post : "") +
              (post ? " | " + planNumber : "") +
              (planNumber ? "人" + "" : "")
          }}
        </div>
      </div>
      <div class="column">
        <el-button type="primary" @click="showDialog('application')"
          >立即报名</el-button
        >
        <applicationNow ref="application"></applicationNow>
      </div>
    </div>
    <div class="postDesc" v-show="zphdlx == 1">
      <moduleTitle title="岗位描述"> </moduleTitle>
      <div v-if="zplb == 3">
        <div class="title">岗位职责</div>
        <div>
          {{ gwzz || "无" }}
        </div>
      </div>
      <div v-if="zplb == 4">
        <div class="title">薪酬待遇</div>
        <div>
          {{ xcdy || "无" }}
        </div>
      </div>
      <div>
        <div class="title">学历要求</div>
        <div>
          {{ degreeLimit || "无" }}
        </div>
      </div>
      <div>
        <div class="title">专业要求</div>
        <div>
          {{ zyyq || "无" }}
        </div>
      </div>
      <div>
        <div class="title">年龄要求</div>
        <div>
          {{ ageLimit || "无" }}
        </div>
      </div>
      <div>
        <div class="title">资格条件</div>
        <div>
          {{ zgtj || "无" }}
        </div>
      </div>
      <!-- <div>
        <div class="title">专业技术资格或职业资格条件</div>
        <div>
          {{ zyjszg || "无" }}
        </div>
      </div> -->
      <div>
        <div class="title">知识技能及能力素质要求</div>
        <div>
          {{ zzjnjnlszyq || "无" }}
        </div>
      </div>
      <div v-if="zplb == 3">
        <div class="title">优先条件</div>
        <div>
          {{ yxtj || "无" }}
        </div>
      </div>
      <div v-if="zplb == 4">
        <div class="title">工作地点</div>
        <div>
          {{ gzdd || "无" }}
        </div>
      </div>
    </div>
    <div class="postDesc" v-show="zphdlx == 2">
      <moduleTitle title="岗位描述"> </moduleTitle>
      <div>
        <div class="title">招聘条件</div>
        <div>
          {{ zptj || "无" }}
        </div>
      </div>
      <div>
        <div class="title">薪酬待遇</div>
        <div>
          {{ xcdy || "无" }}
        </div>
      </div>
      <div>
        <div class="title">工作地点</div>
        <div>
          {{ gzdd || "无" }}
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.body {
  width: 80%;
  margin: 40px auto;

  .post {
    border-top: 10px solid #e9f1f8;
    background-color: #f0f6fc;
    padding: 40px;
    // margin: 20px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .column {
      display: block;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .header {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 20px;
      }

      // .footer {
      // }
    }
  }

  .postDesc {
    padding: 20px;

    .title {
      font-weight: bold;
      margin: 20px 0px;
    }
  }
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import applicationNow from "./components/applicationNow.vue";
export default {
  components: {
    moduleTitle,
    applicationNow
  },
  props: {
    postList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gwzz: "",
      zzjnjnlszyq: "",
      company: "",
      post: "",
      planNumber: "",
      zphdlx: "",
      gwlbid: "",
      zphdmc: "",
      degreeLimit: "",
      zyyq: "",
      ageLimit: "",
      zgtj: "",
      zyjszg: "",
      zphdid: "",
      yxtj: "",

      zptj: "", //招聘条件
      xcdy: "", //薪酬待遇
      gzdd: "", //工作地点

      zplb: "",
    };
  },
  mounted() {
    if (typeof this.$route.query.key != "undefined") {
      this.props = JSON.parse(this.$route.query.key);
      console.log(this.props);
      this.gwzz = this.props.gwzz;
      this.zzjnjnlszyq = this.props.zzjnjnlszyq;
      this.company = this.props.company;
      this.post = this.props.post;
      this.planNumber = this.props.planNumber;
      this.zphdlx = this.props.zphdlx;
      this.gwlbid = this.props.gwlbid;
      this.zphdmc = this.props.zphdmc;
      this.degreeLimit = this.props.degreeLimit;
      this.zyyq = this.props.zyyq;
      this.ageLimit = this.props.ageLimit;
      this.zgtj = this.props.zgtj;
      this.zyjszg = this.props.zyjszg;
      this.zphdid = this.props.zphdid;
      this.yxtj = this.props.yxtj;
      this.zptj = this.props.zptj; //招聘条件
      this.xcdy = this.props.xcdy; //薪酬待遇
      this.gzdd = this.props.gzdd; //工作地点
      this.zplb = this.props.zplb;
    }
  },
  methods: {
    showDialog(refName) {
      let para = {
        zphdlx: this.zphdlx,
        gwlbid: this.gwlbid,
        zphdmc: this.zphdmc,
        company: this.company,
        post: this.post,
        planNumber: this.planNumber,
        zphdid: this.zphdid,
        zplb: this.zplb
      };
      this.$refs[refName].show(para);
    }
  }
};
</script>
